
export class StatesDto {
    stateId?: number;
    stateCode:string;
    stateName: string;
    status: boolean;
    createdAt : Date | any;
    createdUser : number;
    updatedAt : Date | any;
    updatedUser : number;
    versionFlag : number;


}

export const StateDtoDefault : StatesDto = {
    stateId: 0,
    stateCode:"",
    stateName: "",
    status: true,
    createdAt : new Date() ,
    createdUser : 0,
    updatedAt : new Date() ,
    updatedUser : 0,
    versionFlag : 1

};

